<template>
  <b-sidebar lazy backdrop right id="property-panel">
    <div class="container my-3">
      <transition name="slide" mode="out-in">
        <keep-alive>
          <component
            :is="commentToEdit.mode"
            @postSucceded="onPostSucceded"
            @postFailed="onPostFailed"
          ></component>
        </keep-alive>
      </transition>
    </div>
  </b-sidebar>
</template>

<script>
/**
 * @file       Deliberation property panel component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  � Centre coll�gial de d�veloppement de mat�riel didactique, Coll�ge de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { commentsMixin } from "@/modules/comments/mixins";
import modify from "@/modules/comments/components/modify.vue";
import flag from "@/modules/comments/components/flag.vue";
import grade from "@/modules/comments/components/grade.vue";
import message from "@/modules/comments/components/message.vue";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "propertyPanel",
  mixins: [commentsMixin],
  components: {
    modify,
    flag,
    grade,
    message
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    setPubMode(mode) {
      this.$store.commit("deliberations/setPubMode", mode);
    },
    onPostSucceded() {
      this.$root.$emit("bv::toggle::collapse", "property-panel");
    },
    onPostFailed() {
      this.$root.$emit("bv::toggle::collapse", "property-panel");
    }
  }
};
</script>

<style lang="scss" scoped></style>
